module.exports = __webpack_public_path__ + "static/img/indexLong.1977e010.png";